module.exports = __webpack_public_path__ + "img/spell-book.e01a222b.svg";